// import React, { useState } from 'react'
// import { useNavigate } from 'react-router-dom'
// import axios from 'axios'
// import { Button } from 'react-bootstrap'
// // import BackgroundImage from '../Images/Full_Page_Img.png';
// import Countdown from '../Components/Countdown'
// import Swal from 'sweetalert2'

// const ResetPassword = () => {
//   const [email, setEmail] = useState('')
//   const [otp, setOtp] = useState('')
//   const [newPassword, setNewPassword] = useState('')
//   const navigate = useNavigate()

//   const divStyle = {
//     // backgroundImage: `url(${BackgroundImage})`,
//     backgroundSize: 'cover',
//     backgroundPosition: 'center',
//     backgroundRepeat: 'no-repeat',
//     backgroundAttachment: 'fixed',
//     minHeight: '100vh',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     padding: '20px',
//     boxSizing: 'border-box',
//   }

//   const formStyle = {
//     background: 'rgba(209, 185, 228, 0.4)',
//     padding: '20px',
//     borderRadius: '10px',
//     boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.2)',
//     maxWidth: '400px',
//     width: '100%',
//   }

//   const handleSubmit = async (e) => {
//     e.preventDefault()

//     const payload = {
//       email: email,
//       otp: parseInt(otp, 10),
//       new_password: newPassword,
//     }

//     const URL = 'https://tdtlworld.com/dss-kaas-backend/'

//     try {
//       const response = await axios.patch(`${URL}auth/forgot-password/`, payload)

//       if (response.status === 200) {
//         Swal.fire({
//           title: 'Success!',
//           text: 'Password has been changed successfully.',
//           icon: 'success',
//           timer: 1000,
//           timerProgressBar: true,
//           showConfirmButton: false,
//         })
//         navigate('/Log')
//       }
//     } catch (error) {
//       console.error('There was an error resetting the password:', error)
//       Swal.fire({
//         title: 'Error',
//         text: 'Failed to reset password. Please try again.',
//         icon: 'error',
//         timer: 1000,
//         timerProgressBar: true,
//         showConfirmButton: false,
//       })
//     }
//   }

//   const onTimerEnd = () => {
//     // console.log("Timer has finished");
//     Swal.fire({
//       title: 'Error',
//       text: 'OTP expired! Please Try Again',
//       icon: 'error',
//       timer: 1000,
//       timerProgressBar: true,
//       showConfirmButton: false,
//     }).then(() => navigate('/forgot-password'))
//   }

//   return (
//     <div style={divStyle}>
//       <div style={formStyle}>
//         <h2>Password Reset</h2>
//         <form onSubmit={handleSubmit}>
//           <div className='mb-3'>
//             <label htmlFor='email' className='form-label'>
//               Email address
//             </label>
//             <input
//               type='email'
//               className='form-control rounded'
//               id='email'
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//             />
//           </div>
//           <div className='mb-3'>
//             <label htmlFor='otp' className='form-label'>
//               OTP
//             </label>
//             <input
//               type='text'
//               className='form-control rounded'
//               id='otp'
//               value={otp}
//               onChange={(e) => setOtp(e.target.value)}
//               required
//             />
//           </div>
//           <div className='mb-3'>
//             <label htmlFor='newPassword' className='form-label'>
//               New Password
//             </label>
//             <input
//               type='password'
//               className='form-control rounded'
//               id='newPassword'
//               value={newPassword}
//               onChange={(e) => setNewPassword(e.target.value)}
//               required
//             />
//           </div>
//           <Countdown
//             duration={sessionStorage.getItem('OTP_duration')}
//             onFinishCallback={() => onTimerEnd()}
//           />
//           <div className='d-flex w-100 justify-content-center'>
//             <Button
//               style={{ backgroundColor: '#7D52A0' }}
//               type='submit'
//               className='btn btn-primary'
//             >
//               Reset Password
//             </Button>
//           </div>
//         </form>
//       </div>
//     </div>
//   )
// }

// export default ResetPassword

import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faEyeSlash,
  faEnvelope,
  faLock,
  faArrowLeft,
  faKey,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import Swal from "sweetalert2";
import { motion, AnimatePresence } from "framer-motion";
import Lottie from "react-lottie";

const ForgotPasswordPage = () => {
  const URL = "https://tdtlworld.com/dss-kaas-backend/";

  // States for different steps
  const [step, setStep] = useState(1); // 1: Email input, 2: OTP verification, 3: Success
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSentTime, setOtpSentTime] = useState(null);
  const [otpDuration, setOtpDuration] = useState(2); // Default 2 minutes
  const [timeLeft, setTimeLeft] = useState(0);
  const [loading, setLoading] = useState(false);
  const [animationComplete, setAnimationComplete] = useState(false);
  const [passwordValues, setPasswordValues] = useState({
    newPassword: "",
    confirmPassword: "",
    showNewPassword: false,
    showConfirmPassword: false,
  });
  const [errors, setErrors] = useState({
    email: false,
    otp: false,
    password: false,
    confirmPassword: false,
  });

  // Animation options for Lottie
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: {
      v: "5.5.7",
      fr: 30,
      ip: 0,
      op: 60,
      w: 100,
      h: 100,
      nm: "Loading",
      ddd: 0,
      assets: [],
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: "Circle",
          sr: 1,
          ks: {
            o: { a: 0, k: 100 },
            r: {
              a: 1,
              k: [
                { t: 0, s: [0], e: [360] },
                { t: 60, s: [360], e: [720] },
              ],
            },
            p: { a: 0, k: [50, 50, 0] },
            a: { a: 0, k: [0, 0, 0] },
            s: { a: 0, k: [100, 100, 100] },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  d: 1,
                  ty: "el",
                  s: { a: 0, k: [40, 40] },
                  p: { a: 0, k: [0, 0] },
                  nm: "Ellipse Path 1",
                },
                {
                  ty: "st",
                  c: { a: 0, k: [0.49, 0.32, 0.63, 1] },
                  o: { a: 0, k: 100 },
                  w: { a: 0, k: 6 },
                  lc: 2,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  nm: "Stroke 1",
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0] },
                  a: { a: 0, k: [0, 0] },
                  s: { a: 0, k: [100, 100] },
                  r: { a: 0, k: 0 },
                  o: { a: 0, k: 100 },
                  nm: "Transform",
                },
              ],
              nm: "Ellipse 1",
            },
          ],
          ip: 0,
          op: 60,
          st: 0,
          bm: 0,
        },
      ],
    },
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  // Success animation options
  const successOptions = {
    loop: false,
    autoplay: true,
    animationData: {
      v: "5.5.7",
      fr: 30,
      ip: 0,
      op: 60,
      w: 100,
      h: 100,
      nm: "Success",
      ddd: 0,
      assets: [],
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: "Check",
          sr: 1,
          ks: {
            o: { a: 0, k: 100 },
            r: { a: 0, k: 0 },
            p: { a: 0, k: [50, 50, 0] },
            a: { a: 0, k: [0, 0, 0] },
            s: { a: 0, k: [100, 100, 100] },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ty: "st",
                  c: { a: 0, k: [0.49, 0.32, 0.63, 1] },
                  o: { a: 0, k: 100 },
                  w: { a: 0, k: 6 },
                  lc: 2,
                  lj: 2,
                  ml: 1,
                  bm: 0,
                  d: [
                    { n: "d", nm: "dash", v: { a: 0, k: 0 } },
                    { n: "g", nm: "gap", v: { a: 0, k: 0 } },
                    { n: "o", nm: "offset", v: { a: 0, k: 0 } },
                  ],
                  nm: "Stroke",
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0, 0] },
                  a: { a: 0, k: [0, 0] },
                  s: { a: 0, k: [100, 100] },
                  r: { a: 0, k: 0 },
                  o: { a: 0, k: 100 },
                  nm: "Transform",
                },
              ],
              nm: "Shape",
            },
            {
              ty: "sh",
              ks: {
                a: 1,
                k: [
                  {
                    i: { x: 0.5, y: 0 },
                    o: { x: 0.5, y: 1 },
                    t: 10,
                    s: [
                      {
                        c: false,
                        v: [
                          [30, 50],
                          [30, 50],
                        ],
                        i: [
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                        ],
                      },
                    ],
                    e: [
                      {
                        c: false,
                        v: [
                          [30, 50],
                          [45, 65],
                        ],
                        i: [
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                        ],
                      },
                    ],
                  },
                  {
                    i: { x: 0.5, y: 0 },
                    o: { x: 0.5, y: 1 },
                    t: 20,
                    s: [
                      {
                        c: false,
                        v: [
                          [30, 50],
                          [45, 65],
                        ],
                        i: [
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                        ],
                      },
                    ],
                    e: [
                      {
                        c: false,
                        v: [
                          [30, 50],
                          [45, 65],
                          [70, 35],
                        ],
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                      },
                    ],
                  },
                ],
              },
            },
          ],
          ip: 0,
          op: 60,
          st: 0,
          bm: 0,
        },
      ],
    },
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimationComplete(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (otpSentTime && otpDuration) {
      const expiryTime =
        new Date(otpSentTime).getTime() + otpDuration * 60 * 1000;

      const interval = setInterval(() => {
        const now = new Date().getTime();
        const distance = expiryTime - now;

        if (distance <= 0) {
          clearInterval(interval);
          setTimeLeft(0);
        } else {
          const minutes = Math.floor(
            (distance % (1000 * 60 * 60)) / (1000 * 60),
          );
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);
          setTimeLeft({ minutes, seconds });
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [otpSentTime, otpDuration]);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setErrors({ ...errors, email: false });
  };

  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    if (value.length <= 4) {
      setOtp(value);
      setErrors({ ...errors, otp: false });
    }
  };

  const handlePasswordChange = (field) => (e) => {
    setPasswordValues({
      ...passwordValues,
      [field]: e.target.value,
    });

    if (field === "newPassword") {
      setErrors({ ...errors, password: false });
    } else if (field === "confirmPassword") {
      setErrors({ ...errors, confirmPassword: false });
    }
  };

  const togglePasswordVisibility = (field) => {
    setPasswordValues({
      ...passwordValues,
      [field]: !passwordValues[field],
    });
  };

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePassword = (password) => {
    return password.length >= 8;
  };

  const handleSendOTP = async () => {
    // Validate email
    if (!email || !validateEmail(email)) {
      setErrors({ ...errors, email: true });
      Swal.fire({
        title: "Error!",
        text: "Please enter a valid email address",
        icon: "error",
        background: "#f8f9fa",
        confirmButtonColor: "#B8529E",
      });
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${URL}auth/forgot-password/`, {
        email,
      });

      if (response.data) {
        setOtpSentTime(response.data.OTP_sent);
        setOtpDuration(response.data.OTP_duration);

        Swal.fire({
          title: "Success!",
          text: response.data.message,
          icon: "success",
          background: "#f8f9fa",
          confirmButtonColor: "#7D52A0",
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false,
        });

        setStep(2);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      Swal.fire({
        title: "Error!",
        text:
          error.response?.data?.message ||
          "Failed to send OTP. Please try again.",
        icon: "error",
        background: "#f8f9fa",
        confirmButtonColor: "#B8529E",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async () => {
    // Validate OTP and password
    let hasErrors = false;
    const newErrors = { ...errors };

    if (!otp || otp.length !== 4) {
      newErrors.otp = true;
      hasErrors = true;
    }

    if (!validatePassword(passwordValues.newPassword)) {
      newErrors.password = true;
      hasErrors = true;
    }

    if (passwordValues.newPassword !== passwordValues.confirmPassword) {
      newErrors.confirmPassword = true;
      hasErrors = true;
    }

    if (hasErrors) {
      setErrors(newErrors);
      Swal.fire({
        title: "Error!",
        text: "Please check your inputs and try again.",
        icon: "error",
        background: "#f8f9fa",
        confirmButtonColor: "#B8529E",
      });
      return;
    }

    setLoading(true);

    try {
      const response = await axios.patch(`${URL}auth/forgot-password/`, {
        email,
        otp: otp,
        new_password: passwordValues.newPassword,
      });

      if (response.data) {
        Swal.fire({
          title: "Success!",
          text: "Your password has been reset successfully!",
          icon: "success",
          background: "#f8f9fa",
          confirmButtonColor: "#7D52A0",
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false,
        });

        setStep(3);
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      Swal.fire({
        title: "Error!",
        text:
          error.response?.data?.message ||
          "OTP verification failed. Please try again.",
        icon: "error",
        background: "#f8f9fa",
        confirmButtonColor: "#B8529E",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleResendOTP = async () => {
    setLoading(true);

    try {
      const response = await axios.post(`${URL}auth/forgot-password/`, {
        email,
      });

      if (response.data) {
        setOtpSentTime(response.data.OTP_sent);
        setOtpDuration(response.data.OTP_duration);

        Swal.fire({
          title: "Success!",
          text: "OTP has been resent to your email",
          icon: "success",
          background: "#f8f9fa",
          confirmButtonColor: "#7D52A0",
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Error resending OTP:", error);
      Swal.fire({
        title: "Error!",
        text:
          error.response?.data?.message ||
          "Failed to resend OTP. Please try again.",
        icon: "error",
        background: "#f8f9fa",
        confirmButtonColor: "#B8529E",
      });
    } finally {
      setLoading(false);
    }
  };

  // If animation is not complete, show loading animation
  if (!animationComplete) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <Lottie options={defaultOptions} height={120} width={120} />
          <h3
            style={{
              marginTop: 20,
              color: "#7D52A0",
              fontFamily: "Arial, sans-serif",
              fontWeight: "bold",
            }}
          >
            loading KaaS...
          </h3>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)",
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* Animated background elements */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          overflow: "hidden",
          pointerEvents: "none",
          zIndex: -1,
        }}
      >
        {[...Array(5)].map((_, i) => (
          <motion.div
            key={i}
            initial={{
              x: Math.random() * window.innerWidth,
              y: Math.random() * window.innerHeight,
              opacity: 0.3 + Math.random() * 0.4,
            }}
            animate={{
              x: Math.random() * window.innerWidth,
              y: Math.random() * window.innerHeight,
              opacity: 0.3 + Math.random() * 0.4,
            }}
            transition={{
              duration: 15 + Math.random() * 20,
              repeat: Number.POSITIVE_INFINITY,
              repeatType: "reverse",
            }}
            style={{
              position: "absolute",
              width: 100 + Math.random() * 150,
              height: 100 + Math.random() * 150,
              borderRadius: "50%",
              background:
                i % 2 === 0
                  ? "radial-gradient(circle, rgba(184,82,158,0.1) 0%, rgba(184,82,158,0) 70%)"
                  : "radial-gradient(circle, rgba(57,83,163,0.1) 0%, rgba(57,83,163,0) 70%)",
              filter: "blur(20px)",
            }}
          />
        ))}
      </div>

      <div className="container" style={{ maxWidth: "500px", padding: "20px" }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          style={{
            background: "rgba(255, 255, 255, 0.9)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            borderRadius: "20px",
            padding: "40px",
            boxShadow: "0 15px 35px rgba(0, 0, 0, 0.1)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
          }}
        >
          {/* Step 1: Email Input */}
          <AnimatePresence mode="wait">
            {step === 1 && (
              <motion.div
                key="step1"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 20 }}
                transition={{ duration: 0.3 }}
              >
                <div style={{ textAlign: "center", marginBottom: "30px" }}>
                  <h2
                    style={{
                      fontSize: "2rem",
                      fontWeight: "bold",
                      color: "#3953A3",
                      background: "linear-gradient(45deg, #3953A3, #B8529E)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Forgot Password
                  </h2>
                  <p style={{ color: "#666", marginTop: "10px" }}>
                    Enter your email address and we'll send you an OTP to reset
                    your password
                  </p>
                </div>

                <div style={{ marginBottom: "25px" }}>
                  <label
                    htmlFor="email"
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "500",
                      color: "#333",
                    }}
                  >
                    Email Address
                  </label>
                  <div
                    style={{
                      display: "flex",
                      border: errors.email
                        ? "1px solid #dc3545"
                        : "1px solid #ced4da",
                      borderRadius: "5px",
                      overflow: "hidden",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <div
                      style={{
                        background: "#3953A3",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        padding: "0 15px",
                      }}
                    >
                      <FontAwesomeIcon icon={faEnvelope} />
                    </div>
                    <input
                      type="email"
                      id="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={handleEmailChange}
                      style={{
                        border: "none",
                        padding: "12px 15px",
                        flex: 1,
                        outline: "none",
                        background: "transparent",
                      }}
                    />
                  </div>
                  {errors.email && (
                    <p
                      style={{
                        color: "#dc3545",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      Please enter a valid email address
                    </p>
                  )}
                </div>

                <motion.div
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <button
                    onClick={handleSendOTP}
                    disabled={loading}
                    style={{
                      width: "100%",
                      padding: "12px",
                      border: "none",
                      borderRadius: "30px",
                      background: loading
                        ? "#9c7fb5"
                        : "linear-gradient(45deg, #7D52A0, #B8529E)",
                      color: "white",
                      fontSize: "16px",
                      fontWeight: "bold",
                      cursor: loading ? "default" : "pointer",
                      boxShadow: "0 4px 15px rgba(125, 82, 160, 0.3)",
                      transition: "all 0.3s ease",
                    }}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                          style={{ marginRight: "8px" }}
                        ></span>
                        Sending OTP...
                      </>
                    ) : (
                      "Send OTP"
                    )}
                  </button>
                </motion.div>

                <div style={{ textAlign: "center", marginTop: "25px" }}>
                  <a
                    href="/db-shiksha/kaas/login"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      color: "#7D52A0",
                      textDecoration: "none",
                      fontWeight: "500",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => (e.target.style.color = "#B8529E")}
                    onMouseOut={(e) => (e.target.style.color = "#7D52A0")}
                  >
                    <FontAwesomeIcon
                      icon={faArrowLeft}
                      style={{ marginRight: "8px" }}
                    />
                    Back to Login
                  </a>
                </div>
              </motion.div>
            )}

            {/* Step 2: OTP Verification and New Password */}
            {step === 2 && (
              <motion.div
                key="step2"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 20 }}
                transition={{ duration: 0.3 }}
              >
                <div style={{ textAlign: "center", marginBottom: "30px" }}>
                  <h2
                    style={{
                      fontSize: "2rem",
                      fontWeight: "bold",
                      color: "#3953A3",
                      background: "linear-gradient(45deg, #3953A3, #B8529E)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Verify OTP
                  </h2>
                  <p style={{ color: "#666", marginTop: "10px" }}>
                    Enter the OTP sent to {email} and set your new password
                  </p>
                </div>

                <div style={{ marginBottom: "20px" }}>
                  <label
                    htmlFor="otp"
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "500",
                      color: "#333",
                    }}
                  >
                    OTP Code
                  </label>
                  <div
                    style={{
                      display: "flex",
                      border: errors.otp
                        ? "1px solid #dc3545"
                        : "1px solid #ced4da",
                      borderRadius: "5px",
                      overflow: "hidden",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <div
                      style={{
                        background: "#3953A3",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        padding: "0 15px",
                      }}
                    >
                      <FontAwesomeIcon icon={faKey} />
                    </div>
                    <input
                      type="text"
                      id="otp"
                      placeholder="Enter 4-digit OTP"
                      value={otp}
                      onChange={handleOtpChange}
                      style={{
                        border: "none",
                        padding: "12px 15px",
                        flex: 1,
                        outline: "none",
                        background: "transparent",
                        letterSpacing: "5px",
                        fontWeight: "bold",
                      }}
                      maxLength={4}
                    />
                  </div>
                  {errors.otp && (
                    <p
                      style={{
                        color: "#dc3545",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      Please enter a valid 4-digit OTP
                    </p>
                  )}

                  {timeLeft && timeLeft.minutes !== undefined && (
                    <p
                      style={{
                        fontSize: "14px",
                        color: "#666",
                        marginTop: "8px",
                      }}
                    >
                      OTP expires in: {timeLeft.minutes}:
                      {timeLeft.seconds < 10
                        ? `0${timeLeft.seconds}`
                        : timeLeft.seconds}
                    </p>
                  )}

                  {timeLeft &&
                    timeLeft.minutes === 0 &&
                    timeLeft.seconds === 0 && (
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#dc3545",
                          marginTop: "8px",
                        }}
                      >
                        OTP has expired. Please request a new one.
                      </p>
                    )}
                </div>

                <div style={{ marginBottom: "20px" }}>
                  <label
                    htmlFor="newPassword"
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "500",
                      color: "#333",
                    }}
                  >
                    New Password
                  </label>
                  <div
                    style={{
                      display: "flex",
                      border: errors.password
                        ? "1px solid #dc3545"
                        : "1px solid #ced4da",
                      borderRadius: "5px",
                      overflow: "hidden",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <div
                      style={{
                        background: "#3953A3",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        padding: "0 15px",
                      }}
                    >
                      <FontAwesomeIcon icon={faLock} />
                    </div>
                    <input
                      type={
                        passwordValues.showNewPassword ? "text" : "password"
                      }
                      id="newPassword"
                      placeholder="Enter new password"
                      value={passwordValues.newPassword}
                      onChange={handlePasswordChange("newPassword")}
                      style={{
                        border: "none",
                        padding: "12px 15px",
                        flex: 1,
                        outline: "none",
                        background: "transparent",
                      }}
                    />
                    <button
                      type="button"
                      onClick={() =>
                        togglePasswordVisibility("showNewPassword")
                      }
                      style={{
                        border: "none",
                        background: "transparent",
                        padding: "0 15px",
                        cursor: "pointer",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={
                          passwordValues.showNewPassword ? faEyeSlash : faEye
                        }
                        style={{ color: "#6c757d" }}
                      />
                    </button>
                  </div>
                  {errors.password && (
                    <p
                      style={{
                        color: "#dc3545",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      Password must be at least 8 characters long
                    </p>
                  )}
                </div>

                <div style={{ marginBottom: "25px" }}>
                  <label
                    htmlFor="confirmPassword"
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "500",
                      color: "#333",
                    }}
                  >
                    Confirm Password
                  </label>
                  <div
                    style={{
                      display: "flex",
                      border: errors.confirmPassword
                        ? "1px solid #dc3545"
                        : "1px solid #ced4da",
                      borderRadius: "5px",
                      overflow: "hidden",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <div
                      style={{
                        background: "#3953A3",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        padding: "0 15px",
                      }}
                    >
                      <FontAwesomeIcon icon={faLock} />
                    </div>
                    <input
                      type={
                        passwordValues.showConfirmPassword ? "text" : "password"
                      }
                      id="confirmPassword"
                      placeholder="Confirm new password"
                      value={passwordValues.confirmPassword}
                      onChange={handlePasswordChange("confirmPassword")}
                      style={{
                        border: "none",
                        padding: "12px 15px",
                        flex: 1,
                        outline: "none",
                        background: "transparent",
                      }}
                    />
                    <button
                      type="button"
                      onClick={() =>
                        togglePasswordVisibility("showConfirmPassword")
                      }
                      style={{
                        border: "none",
                        background: "transparent",
                        padding: "0 15px",
                        cursor: "pointer",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={
                          passwordValues.showConfirmPassword
                            ? faEyeSlash
                            : faEye
                        }
                        style={{ color: "#6c757d" }}
                      />
                    </button>
                  </div>
                  {errors.confirmPassword && (
                    <p
                      style={{
                        color: "#dc3545",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      Passwords do not match
                    </p>
                  )}
                </div>

                <div
                  style={{ display: "flex", gap: "15px", marginBottom: "20px" }}
                >
                  <motion.div
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    style={{ flex: 1 }}
                  >
                    <button
                      onClick={handleVerifyOTP}
                      disabled={loading}
                      style={{
                        width: "100%",
                        padding: "12px",
                        border: "none",
                        borderRadius: "30px",
                        background: loading
                          ? "#9c7fb5"
                          : "linear-gradient(45deg, #7D52A0, #B8529E)",
                        color: "white",
                        fontSize: "16px",
                        fontWeight: "bold",
                        cursor: loading ? "default" : "pointer",
                        boxShadow: "0 4px 15px rgba(125, 82, 160, 0.3)",
                        transition: "all 0.3s ease",
                      }}
                    >
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                            style={{ marginRight: "8px" }}
                          ></span>
                          Verifying...
                        </>
                      ) : (
                        "Reset Password"
                      )}
                    </button>
                  </motion.div>
                </div>

                <div style={{ textAlign: "center", marginTop: "10px" }}>
                  <p style={{ fontSize: "14px", color: "#666" }}>
                    Didn't receive the OTP?{" "}
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleResendOTP();
                      }}
                      style={{
                        color: "#7D52A0",
                        textDecoration: "none",
                        fontWeight: "500",
                        transition: "all 0.3s ease",
                      }}
                      onMouseOver={(e) => (e.target.style.color = "#B8529E")}
                      onMouseOut={(e) => (e.target.style.color = "#7D52A0")}
                    >
                      Resend OTP
                    </a>
                  </p>
                </div>

                <div style={{ textAlign: "center", marginTop: "20px" }}>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setStep(1);
                    }}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      color: "#7D52A0",
                      textDecoration: "none",
                      fontWeight: "500",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => (e.target.style.color = "#B8529E")}
                    onMouseOut={(e) => (e.target.style.color = "#7D52A0")}
                  >
                    <FontAwesomeIcon
                      icon={faArrowLeft}
                      style={{ marginRight: "8px" }}
                    />
                    Change Email
                  </a>
                </div>
              </motion.div>
            )}

            {/* Step 3: Success */}
            {step === 3 && (
              <motion.div
                key="step3"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                style={{ textAlign: "center" }}
              >
                <div style={{ marginBottom: "30px" }}>
                  <Lottie options={successOptions} height={120} width={120} />
                  <h2
                    style={{
                      fontSize: "2rem",
                      fontWeight: "bold",
                      marginTop: "20px",
                      color: "#3953A3",
                      background: "linear-gradient(45deg, #3953A3, #B8529E)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Password Reset Successful!
                  </h2>
                  <p style={{ color: "#666", marginTop: "10px" }}>
                    Your password has been reset successfully. You can now log
                    in with your new password.
                  </p>
                </div>

                <motion.div
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <a
                    href="/db-shiksha/kaas/login"
                    style={{
                      display: "inline-block",
                      padding: "12px 30px",
                      border: "none",
                      borderRadius: "30px",
                      background: "linear-gradient(45deg, #7D52A0, #B8529E)",
                      color: "white",
                      fontSize: "16px",
                      fontWeight: "bold",
                      textDecoration: "none",
                      boxShadow: "0 4px 15px rgba(125, 82, 160, 0.3)",
                      transition: "all 0.3s ease",
                    }}
                  >
                    Back to Login
                  </a>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
